/*
jQuery( ".form-nav button" ).click(function() {
	
	var page = jQuery( this ).data( 'page' );
	
	var page_class = 'page-' + page;
	
	jQuery( '.form-nav button' ).removeClass( 'active' );
	jQuery( this ).addClass( 'active' );
	
	jQuery( '#parent-sign-up' ).removeClass();
	
	jQuery( '#parent-sign-up' ).addClass( page_class );
	
  
});*/

function get_signup_calendar() {
	
	if( jQuery('body').hasClass('page-template-template-sign-up') ) {
	
		var consultant = jQuery( '#input_1_19' ).val();
		var day = jQuery('#parent-sign-up').data('day');
		var month = jQuery('#parent-sign-up').data('month');
		var year = jQuery('#parent-sign-up').data('year');
		var timezone = jQuery( '#input_1_7' ).val();
	}
	
	else {
		
		var consultant = jQuery( '#input_5_11' ).val();
		var day = jQuery('#add-student').data('day');
		var month = jQuery('#add-student').data('month');
		var year = jQuery('#add-student').data('year');
		var timezone = jQuery( '#input_5_17' ).val();

		
	}

	print_consultant_calendar( consultant, month, day, year, timezone );
	
}

jQuery( "button.continue" ).click(function() {
	
	var page = jQuery( '.form-nav button.active' ).data( 'page' );
	var next_page = parseInt( page ) + 1;
	var page_class = 'page-' + next_page;
	var next_button = '.form-nav button[data-page="' + next_page + '"]';
	
    var invalid = false;
	
	if( page == '1' ) {
		
		jQuery('#input_1_3, #input_1_4, #input_1_5, #input_1_6, #input_1_31_1, #input_1_31_3, #input_1_31_4, #input_1_31_5, #input_1_38, #input_1_38_2, #input_1_33' ).each(function() {
			
			if( jQuery(this).val() == '' ) {
				
				//alert( 'Please complete the required fields.' );
				invalid = true;
				
			}
			
		});
			
			//alert( 'Please complete the required fields.' );
		///return false;
			
		
		
		jQuery('span.firstname').text( jQuery('#input_1_3').val() );
		jQuery('span.lastname').text( jQuery('#input_1_4').val() );
		jQuery('span.phone').text( jQuery('#input_1_5').val() );
		jQuery('span.address1').text( jQuery('#input_1_31_1').val() );
		jQuery('span.address2').text( jQuery('#input_1_31_2').val() );
		jQuery('span.city').text( jQuery('#input_1_31_3').val() );
		jQuery('span.state').text( jQuery('#input_1_31_4').val() );
		jQuery('span.zip').text( jQuery('#input_1_31_5').val() );
		jQuery('span.country').text( jQuery('#input_1_31_6').val() );
		jQuery('span.timezone').text( jQuery('#input_1_7').val() );
		jQuery('span.email').text( jQuery('#input_1_6').val() );
		jQuery('span.username').text( jQuery('#input_1_33').val() );
		
	}
	
	if( page == '2' ) {
		
		jQuery('#input_1_11, #input_1_12, #input_1_31_1, #input_1_31_3, #input_1_31_4, #input_1_31_5, #input_1_13_1, #input_1_13_2, #input_1_13_3, #input_1_37, #input_1_39' ).each(function() {
			
			if( jQuery(this).val() == '' ) {
				
				//alert( 'Please complete the required fields.' );
				invalid = true;
				
			}
			
		});
		
		jQuery('span.relationship').text( jQuery('#input_1_10').val() );
		jQuery('span.student_firstname').text( jQuery('#input_1_11').val() );
		jQuery('span.student_lastname').text( jQuery('#input_1_12').val() );
		jQuery('span.birth_month').text( jQuery('#input_1_13_1').val() );
		jQuery('span.birth_day').text( jQuery('#input_1_13_2').val() );
		jQuery('span.birth_year').text( jQuery('#input_1_13_3').val() );
		jQuery('span.student_timezone').text( jQuery('#input_1_15').val() );
		jQuery('span.grade').text( jQuery('#input_1_37').val() );
		jQuery('span.start_year').text( jQuery('#input_1_16_3').val() );
		jQuery('span.end_year').text( jQuery('#input_1_17_3').val() );
		
	}
	
	if( page == '3' ) {
		
		if( jQuery('.consultant-result.selected' ).length == "" ) {
			
			alert( 'Please select a consultant.' );
			return false;
			
		}
		
		jQuery('span.consultant_name').text( jQuery('.consultant-result.selected h2').text() );
		
	}
	
	if( page == '4' ) {
		
		if( jQuery('.time-block.choice' ).length == "" ) {
			
			alert( 'Please select a time.' );
			return false;
			
		}
		
		jQuery('span.day').text( jQuery('.consultant-calendar').data('day') );
		jQuery('span.month').text( jQuery('.consultant-calendar').data('month') );
		jQuery('span.year').text( jQuery('.consultant-calendar').data('year') );
		jQuery('span.time').text( jQuery('.time-block.choice').text());
		
	}
	
	if( page == '5' ) {
		
		if( jQuery('#input_1_36_5' ).val() == ''  ) {
			
			alert( 'Please complete the required fields.' );
			return false;
			
		}
		
		jQuery('span.application_fee').text( jQuery('#ginput_base_price_1_23').val() );
		jQuery('span.name_on_card').text( jQuery('#input_1_36_5').val() );
		
	}
	
	if( invalid == true ) {
		alert( 'Please complete the required fields.' );
		return false;
	}
	
	else {
		jQuery( '.form-nav button' ).removeClass( 'active' );
		jQuery( next_button ).addClass( 'active' );
	
		jQuery( '#parent-sign-up' ).removeClass();
		jQuery( '#parent-sign-up' ).addClass( page_class );
	}	
	  
});

jQuery( "button.back" ).click(function() {
	
	var page = jQuery( '.form-nav button.active' ).data( 'page' );
	var next_page = parseInt( page ) - 1;
	var page_class = 'page-' + next_page;
	var next_button = '.form-nav button[data-page="' + next_page + '"]';
	
	jQuery( '.form-nav button' ).removeClass( 'active' );
	jQuery( next_button ).addClass( 'active' );
	
	jQuery( '#parent-sign-up' ).removeClass();
	jQuery( '#parent-sign-up' ).addClass( page_class );
	  
});

jQuery( "button.checkout" ).click(function() {
	
	var invalid = false;
	
	jQuery('#input_5_1, #input_5_2, #input_5_3_1, #input_5_3_2, #input_5_3_3, #input_5_4_6, #input_5_7_1, #input_5_17, #input_5_18, #input_5_19, #input_5_20' ).each(function() {
			
		if( jQuery(this).val() == '' ) {
				
			//alert( 'Please complete the required fields.' );
			invalid = true;
				
		}
			
	});
	
	if( invalid == true ) {
			
		alert( 'Please complete the required fields.' );
		return false;
			
	}
	
	else {
		jQuery('#add-student').removeClass('page-1');
		jQuery('#add-student').addClass('page-2');
		jQuery('p.hide').hide();
		
		var user_id = jQuery('#add-student').data('user');
		jQuery('#input_5_16').val( user_id );
	}
	
});

jQuery( "button.add-student" ).click(function(e) {
	
	e.stopPropagation();
	jQuery('#gform_submit_button_5').trigger( "click" );
	
});


jQuery(document).ready(function(){
 
    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
 
        if(formId == 5) {    
	        jQuery('button.add-student').hide();
        
        } 
    });
 
});

jQuery( "button.submit-application" ).click(function(e) {
	
	e.stopPropagation();
	console.log('ran');
	
	jQuery('.submit-application').hide();
	jQuery('.back').hide();
	jQuery('.loading-message').show();
	
	
	jQuery('.review-order').hide();
	jQuery('#gform_submit_button_1').trigger( "click" );
	
	setTimeout(function(){
    
        if(jQuery('#input_1_36_1').hasClass('StripeElement--invalid') ) {
	     	jQuery('.loading-message').hide();
	       jQuery('.submit-application').show();
	       jQuery('#field_1_36').css('height','auto');
	        jQuery('#field_1_36').css('visibility','visible');
	        jQuery('#field_1_36').css('position','relative');
	        jQuery('#field_1_36').css('top','auto');
	        jQuery('#field_1_36').css('left','auto');
	        
        }
	
	},5000);
		  
});

jQuery( ".all-consultants .consultant-result" ).click(function(e) {
	
	e.preventDefault();
	var consultant = jQuery(this).data('consultant');
	jQuery('.consultant-result').removeClass('selected');
	jQuery(this).addClass('selected');
	jQuery( '#input_1_19' ).val( consultant );
	jQuery( '#input_5_11' ).val( consultant );
	
	jQuery('.calendar-wrap').show();
	
	jQuery('#add-student h3').show();
	
	jQuery('#add-student p.help').show();
	
	get_signup_calendar();
		  
});

jQuery( 'body' ).on('click', '.time-block.selected', function(e){ 
	
	if( jQuery(this).hasClass('available') ) {
		
		if( jQuery('body').hasClass('page-template-template-sign-up') ) {
		
			e.preventDefault();
			
			var day = jQuery('.calendar-day button.active').data('day');
			var month = jQuery('.consultant-calendar').data('month');
			var year = jQuery('.consultant-calendar').data('year');
			
			jQuery('button.time-block').removeClass('choice');
	
			jQuery(this).addClass('choice');
			
			var ID = jQuery('.time-block.choice').data('id');
		
			//set form fields
			jQuery( '#input_1_29' ).val( month );
			jQuery( '#input_1_27' ).val( day );
			jQuery( '#input_1_28' ).val( year );
			jQuery( '#input_1_21' ).val( ID );
			
			jQuery( '#input_5_12' ).val( month );
			jQuery( '#input_5_13' ).val( day );
			jQuery( '#input_5_14' ).val( year );
			jQuery( '#input_5_15' ).val( ID );
		
		}
		
		if( jQuery('body').hasClass('page-template-template-add-another-student') ) {
		
			e.preventDefault();
			
			var day = jQuery('.calendar-day button.active').data('day');
			var month = jQuery('.consultant-calendar').data('month');
			var year = jQuery('.consultant-calendar').data('year');
			
			jQuery('button.time-block').removeClass('choice');
	
			jQuery(this).addClass('choice');
			
			var ID = jQuery('.time-block.choice').data('id');
		
			//set form fields		
			jQuery( '#input_5_12' ).val( month );
			jQuery( '#input_5_13' ).val( day );
			jQuery( '#input_5_14' ).val( year );
			jQuery( '#input_5_15' ).val( ID );
			
			jQuery('.form-buttons').show();
		
		}
	
	}
	
	jQuery(this).blur();
	
});

jQuery(document).on( 'keypress', '.gform_wrapper', function (e) {
    var code = e.keyCode || e.which;
    if ( code == 13 && ! jQuery( e.target ).is( 'textarea,input[type="submit"],input[type="button"]' ) ) {
        e.preventDefault();
        return false;
    }
} );

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
 
    if(jQuery(".gform_submission_error").length != 0){ 
	        
	    jQuery('.submit-application').show();
	        
    }
 
});

jQuery( "#input_5_17" ).change(function() {
	
	if( jQuery( ".all-consultants .consultant-result" ).hasClass('selected') ) {
		
		get_signup_calendar();
		
	}
	
});